import AnswerFileFullScreen from './src/main'

export default AnswerFileFullScreen



// WEBPACK FOOTER //
// ./src/views/question-review/components/AnswerFileFullScreen/index.js